import Vue from 'vue';
import Vuex from 'vuex';
import createCache from 'vuex-cache';

Vue.use(Vuex);

// Import modules
import ui from '@/store/modules/ui';
import tenant from '@/store/modules/tenant';
import core from '@/store/modules/core';
import axioms from '@/store/modules/axioms';

// Declare debug
const debug = process.env.NODE_ENV !== 'production'

// Equal to 1 hours in milliseconds.
const options = { timeout: 1 * 60 * 60 * 1000 };

// Create a store
const store = new Vuex.Store({
    modules: {
        ui: ui,
        tenant: tenant,
        core: core,
        axioms: axioms
    },
    strict: debug,
    plugins: [createCache({ timeout: options })], // activate plugin
})

export default store;